<template>
  <div class="overlay" @click.self="closePopup">
    <div class="login-wrapper">
      <!-- LEFT IMAGE -->
      <div class="left-section">
        <!-- <div class="overlay-content"></div> -->
        <img src="../assets/chooseapp-preview.png" alt="Chooseapp Logo" />
        <span class="brand-text">ChooseApp</span>
      </div>

      <!-- RIGHT LOGIN -->
      <div class="login-popup">
        <button class="close-popup-btn" @click="closePopup">✕</button>
        <div v-if="step === 1" class="form-section">
          <h2 style="text-align: left">Login or Sign Up to Chooseapp</h2>
          <br />
          <label class="form-label" style="text-align: left">Mobile Number</label>
          <div class="input-box">
            <span class="country-flag">🇮🇳</span>
            <span class="country-code">+91</span>
            <input v-model="mobileNumber" type="text" placeholder="Enter Mobile Number" />
          </div>
          <v-btn block color="primary" class="white--text mt-3 py-5" :disabled="mobileNumber.length != 10" elevation="0"
            @click="sendOtp" :loading="isLoading">
            CONTINUE
          </v-btn>
        </div>

        <!-- OTP Step -->
        <div v-if="step === 2" class="form-section">
          <h2 style="text-align: left">Enter OTP</h2>
          <input v-model="otp" type="text" placeholder="Enter OTP" class="input-box" />
          <v-btn block color="primary" class="white--text mt-3 py-5" :disabled="otp.length != 4" elevation="0"
            @click="verifyOtp" :loading="isLoading">
            VERIFY OTP
          </v-btn>
        </div>

        <!-- Registration Step (only if new user) -->
        <div v-if="step === 3" class="form-section">
          <h2 style="text-align: left">Complete Your Registration</h2>
          <input v-model="firstName" type="text" placeholder="First Name" class="input-box w-100" />
          <br />
          <input v-model="email" type="email" placeholder="Email" class="input-box w-100" />
          <v-btn block color="primary" class="white--text mt-3 py-5" :disabled="otp.length != 4" elevation="0"
            @click="registerUser" :loading="isLoading">
            REGISTER
          </v-btn>
        </div>

        <!-- Terms -->
        <div class="terms-text">
          By proceeding, you agree to Chooseapp
          <a href="#">Privacy Policy</a>, <a href="#">User Agreement</a> and
          <a href="#">T&Cs</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "LoginPopup",
  data() {
    return {
      step: 1,
      mobileNumber: "",
      otp: "",
      firstName: "",
      lastName: "",
      email: "",
      isLoading: false
    };
  },
  methods: {
    ...mapActions("auth", ["logIn", "logOut"]),
    closePopup() {
      this.$emit("close");
    },
    async sendOtp() {
      this.isLoading = true
      try {
        let payload = {
          phone: this.mobileNumber,
          is_login: 1,
        }
        let res = await this.logIn(payload);
        if (res.data.success || res.data.message === "OTP sent successfully") {
          this.isLoading = false
          this.step = 2;
        } else {
          this.isLoading = false
          alert("Failed to send OTP: " + (res.data.message || "Unknown error"));
        }
      } catch (error) {
        console.error("Error sending OTP:", error.response?.data || error);
        alert("Error sending OTP. Please try again.");
      }
    },
    async verifyOtp() {
      this.isLoading = true
      let payload = {
        phone: this.mobileNumber,
        otp: this.otp,
        is_login: 1,
      }
      let res = await this.logIn(payload);
      if (
        res.data.message === "User is Logged in Successfully"
      ) {
        this.isLoading = false
        console.log('res' , res.data);
        this.$emit("login-success", res.data.data);
        this.closePopup();
      } else if (res.data.message === 'Otp Verified Successfully') {
        this.isLoading = false
        this.step = 3;
      } else {
        alert("Invalid OTP");
      }
    },

    // async verifyOtp() {
    //   try {
    //     const res = await axios.post(`${this.apiUrl}/test_login`, {
    //       phone: this.mobileNumber,
    //       otp: this.otp,
    //       is_login: 1,
    //     });

    //     if (
    //       res.data.success ||
    //       res.data.message === "User is Logged in Successfully" ||
    //       res.data.is_login === 1
    //     ) {
    //       // ✅ Save user info
    //       localStorage.setItem("user", JSON.stringify(res.data.user));
    //       this.$emit("login-success", res.data.user);

    //       // Close popup without alert
    //       this.closePopup();
    //     } else if (
    //       res.data.user_exists === false ||
    //       res.data.message === "User not found"
    //     ) {
    //       this.step = 3; // go to registration
    //     } else {
    //       alert("OTP verification failed: " + (res.data.message || "Invalid OTP"));
    //     }
    //   } catch (error) {
    //     console.error("OTP verification failed:", error.response?.data || error);
    //     alert("OTP verification failed. Please check the OTP and try again.");
    //   }
    // },

    async registerUser() {
      this.isLoading = true
      try {
        let payload ={
          first_name: this.firstName,
          last_name: this.firstName,
          email: this.email,
          phone: this.mobileNumber,
          otp: this.otp,
          password: "123456",
          is_login: 1,
          password_confirmation: "123456",
          terms: true,
        };
        let res = await this.logIn(payload);

        if (
           res.data.message === "User is Logged in Successfully" 
        ) {
          this.isLoading = false
          this.$emit("login-success", res.data);
          this.closePopup();
        } else {
          this.isLoading = false
          alert(
            "Registration failed: " + (res.data.message || "Unknown error")
          );
        }
      } catch (error) {
        this.isLoading = false
        console.error("Registration failed:", error.response?.data || error);
        alert("Registration failed. Please try again.");
      }
    },
  },
};
</script>

<style scoped>
/* Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 15px;
}

/* Wrapper with 2 columns */
.login-wrapper {
  display: flex;
  width: 800px;
  max-width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* LEFT PANEL */
.left-section {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  /* stack items vertically */
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.left-section img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
  margin-bottom: 12px;
  margin-right: 29px;
  /* space between image and text */
}

.brand-text {
  font-size: 30px;
  /* increased font size */
  font-weight: 700;
  color: #005886;
}


.overlay-content {
  background: rgba(0, 0, 0, 0.4);
  padding: 20px;
  border-radius: 8px;
}

.overlay-content h2 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.overlay-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.overlay-content li {
  margin-bottom: 12px;
  font-size: 15px;
  display: flex;
  align-items: center;
  line-height: 1.4;
}

.overlay-content .icon {
  margin-right: 8px;
  font-size: 18px;
}

/* RIGHT PANEL */
.login-popup {
  flex: 1;
  padding: 30px;
  background: #fff;
  font-family: "Segoe UI", Arial, sans-serif;
  position: relative;
}

/* Tabs */
.tab-buttons {
  display: flex;
  background: #f2f2f2;
  border-radius: 25px;
  padding: 4px;
  margin-bottom: 25px;
}

.tab-buttons button {
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 25px;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  transition: all 0.3s;
}

.tab-buttons .active {
  background: #007bff;
  color: #fff;
  font-weight: 600;
}

/* Form */
.form-section {
  margin-bottom: 20px;
}

.form-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  display: block;
}

.input-box {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 15px;
}

.country-flag {
  margin-right: 6px;
}

.country-code {
  margin-right: 10px;
  font-weight: 500;
  color: #333;
}

.input-box input {
  border: none;
  outline: none;
  flex: 1;
  font-size: 15px;
}

/* Continue Button */
.continue-btn {
  width: 100%;
  padding: 12px;
  margin-top: 15px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
  background: #e0e0e0;
  color: #777;
}

.continue-btn.enabled {
  background: #007bff;
  color: #fff;
  cursor: pointer;
}

/* Divider */
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0;
}

.divider span {
  flex: 1;
  height: 1px;
  background: #ccc;
}

.divider p {
  margin: 0 12px;
  font-size: 14px;
  color: #777;
}

/* Social Buttons */
.social-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.circle-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #ccc;
  font-size: 20px;
  cursor: pointer;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-btn:hover {
  background: #f9f9f9;
}

/* Terms */
.terms-text {
  text-align: center;
  font-size: 12px;
  color: #777;
  margin-top: 18px;
  line-height: 1.4;
}

.terms-text a {
  color: #007bff;
  text-decoration: none;
}

.terms-text a:hover {
  text-decoration: underline;
}

/* ---------------------- */
/* RESPONSIVE DESIGN */
/* ---------------------- */

/* Tablets */
/* Tablets */
@media (max-width: 992px) {
  .login-wrapper {
    flex-direction: column;
    width: 100%;
    max-height: 95%;
    overflow-y: auto;
  }

  .left-section {
    min-height: 200px;
    padding: 20px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .overlay-content {
    max-width: 90%;
    margin: auto;
  }
}

/* Mobiles */
/* Tablets and Mobiles */
@media (max-width: 992px) {
  .left-section {
    display: none;
    /* 👈 Hide image section on tablets & mobiles */
  }

  .login-popup {
    padding: 20px;
    flex: 1;
    width: 100%;
  }

  .tab-buttons button {
    font-size: 14px;
    padding: 10px 0;
  }

  .overlay-content h2 {
    font-size: 18px;
  }

  .overlay-content li {
    font-size: 13px;
  }

  .circle-btn {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}


.close-popup-btn {
  position: absolute;
  top: 0px;
  right: 14px;
  background: transparent;
  border: none;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  z-index: 10;
  transition: color 0.2s;
}

.close-popup-btn:hover {
  color: #007bff;
}
</style>
